var React = require('react');
var Gender = require('./gender');
var Shopify = require('./shopify');

module.exports = React.createClass({

  componentDidMount: function() {
  	document.title = "Mens - Ingledew's Shoes";
  },

  render: function() {

  	return <Gender gender="Mens" tbi_title={CMS.mens.title} tbi_text={CMS.mens.text}
                   tbi_btnText={CMS.mens.btnText} tbi_btnLink={CMS.mens.btnLink}
                   tbi_image={CMS.mens.img} tbi_imageM={CMS.mens.imgM}
                   promo1={CMS.mens.promo1} promo1_img={CMS.mens.promo1_img}
                   promo2={CMS.mens.promo2} promo2_img={CMS.mens.promo2_img}
                   promo3={CMS.mens.promo3} promo3_img={CMS.mens.promo3_img}
                   promo4={CMS.mens.promo4} promo4_img={CMS.mens.promo4_img}
                   promo5={CMS.mens.promo5} promo5_img={CMS.mens.promo5_img}
                   promo6={CMS.mens.promo6} promo6_img={CMS.mens.promo6_img}
                   menus={CMS.mens.categories}>
  	       </Gender>
  }
});